// Tab link

'use strict';

$ice('[data-toggle="tabLink"]', tabLink => {
    tabLink.addEventListener('click', (e) => {
        e.preventDefault();

        document.querySelector(`[data-bs-target="${e.target.hash}"]`).click();
    });
})
